import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion'
import images from '../../app/utlis/image'
import Heading from '../atoms/Heading/Heading'
import ProjectDisplay from '../molecules/ProjectDisplay/ProjectDisplay'
import AppsFaq from '../molecules/AppsFaq/AppsFaq'
import AppsRunning from '../molecules/AppsSupportComponents/AppsRunning/AppsRunning'
import WebsiteSuppIdeaProject from '../molecules/WebsiteSupportComponents/WebsiteSuppIdeaProject/WebsiteSuppIdeaProject'
import DefaultFooter from '../organisms/DefaultFooter/DefaultFooter'
import { getPageData, useData } from '../../app/helper/functions'
import ReliabilityWebsiteSupport from '../molecules/WebsiteSupportComponents/ReliabilityWebsiteSupport/ReliabilityWebsiteSupport'
import WebMaintenanceSupport from '../molecules/WebsiteSupportComponents/WebMaintanenceSupport/WebMaintanenceSupport'

const WebsiteSupportPage = () => {
    const { data } = useData();
    const websiteSupportData = getPageData(data, 'websiteSupportPage');
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div>
            <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8 }}
                className='bg-websiteSupport-bg bg-center bg-cover bg-no-repeat'
            >
                <div className='bg-blackTransparent'>
                    <div className={`flex ${isMobile ? 'flex-col px-4' : 'pr-[10%]'} pb-8 gap-6 ${isMobile ? 'pt-28' : 'pt-52'}`}>
                        <motion.div 
                            initial={{ opacity: 0, x: isMobile ? 0 : -50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}
                            className={`${isMobile ? 'w-full' : 'w-[100%]'} bg-[#ffffff12] rounded-r-3xl ${isMobile ? 'h-auto' : 'h-[550px]'} object-contain overflow-hidden`}
                        >
                            {/* <img src={images.WORDPERSSIMAGE} className='w-full object-cover' /> */}
                        </motion.div>
                        {/* <img src={images.ECOMMERCEIMAGE} className='z-10 w-[60%]' /> */}
                        <motion.div 
                            initial={{ opacity: 0, x: isMobile ? 0 : 50 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className={`text-white flex flex-col gap-2 relative ${isMobile ? 'text-center' : 'text-end'} justify-center items-center`}
                        >
                            <div className={`font-bold ${isMobile ? 'text-4xl' : 'text-6xl'} mb-2`}>{websiteSupportData.title}</div>
                            <div className={`font-normal ${isMobile ? 'text-lg' : 'text-2xl'}`}>{websiteSupportData.description}</div>
                        </motion.div>
                    </div>
                </div>
            </motion.div>
            <div className='bg-darkGreyPrimary'>
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <Heading className={`bg-darkGreyPrimary ${isMobile ? 'pt-8 px-4' : 'pt-12'}`}
                        subTitle='The importance of web maintenance & Support'
                        text="Regular updates and monitoring are necessary for website security, functionality,
                        and alignment with business goals. Neglecting maintenance can cause slow
                        performance, security issues, and outdated content, negatively affecting
                        user experience and SEO. Our services keep your website valuable." />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                    className={isMobile ? 'px-4' : ''}
                >
                    <ReliabilityWebsiteSupport websiteSupportData={websiteSupportData} />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.1 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                    className={isMobile ? 'px-4' : ''}
                >
                    <WebsiteSuppIdeaProject websiteSupportData={websiteSupportData} />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                >
                    <Heading className={`bg-darkGreyPrimary ${isMobile ? 'pt-8 px-4' : 'pt-12'}`}
                        subTitle='Reasons to select us for web maintenance' />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                    className={isMobile ? 'px-4' : ''}
                >
                    <WebMaintenanceSupport websiteSupportData={websiteSupportData} />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                >
                    <ProjectDisplay />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                >
                    <AppsFaq />
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: "easeOut", delay: 0.1 }}
                    className={`${isMobile ? 'pt-6' : 'pt-10'} bg-darkGreyPrimary ${isMobile ? 'px-4' : ''}`}
                >
                    <AppsRunning bgImage='bg-confident-aiHealth-bg' title='Launch your e-commerce development project today.'
                        subtitle='Want to move your business online and boost sales? Our skilled team can create a tailored e-commerce platform that expands with your needs.' />
                </motion.div>
                
                <DefaultFooter />
            </div>
        </div>
    )
}

export default WebsiteSupportPage
